module.exports = __webpack_public_path__ + "img/1.7e36b87f.jpg";